"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Radio = void 0;

var _react = _interopRequireWildcard(require("react"));

var _jsxRuntime = require("react/jsx-runtime");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

let Radio = ({
  id,
  schemaTypeName,
  name,
  option,
  onChange,
  onBlur,
  inputRef,
  label,
  styles,
  field,
  defaultValue
}, ref) => {
  const fullId = `${id}-${option}`;
  const checked = defaultValue == option;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: styles.radioWrap,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("input", {
      id: fullId,
      type: "radio",
      name: name,
      value: option,
      onChange: onChange,
      onBlur: onBlur,
      ref: inputRef,
      defaultChecked: checked,
      className: styles.radio
    }, "val"), /*#__PURE__*/(0, _jsxRuntime.jsx)("label", {
      htmlFor: fullId,
      className: styles.radioLabel,
      children: label
    }, "label")]
  }, option);
};

exports.Radio = Radio;
exports.Radio = Radio = /*#__PURE__*/(0, _react.forwardRef)(Radio);